import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef(
  ({ className, type, suffix, label, icon, ...props }, ref) => {
    return (
      <div className={`relative ${className || ''}`}>
        {/* Label and Icon positioned on top border */}
        {(label || icon) && (
          <div className="absolute -top-2 left-4 bg-white px-2 z-10">
            <div className="flex items-center gap-1">
              {icon && (
                <div className="flex-shrink-0 text-gray-600">{icon}</div>
              )}
              {label && (
                <span className="text-sm font-montserrat text-gray-600">
                  {label}
                </span>
              )}
            </div>
          </div>
        )}

        <input
          type={type}
          className={cn(
            "flex h-14 w-full rounded-full border border-[#999] bg-transparent px-3 py-1 text-lg shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-sm placeholder:text-muted-foreground focus:border-2 focus:border-[#2b364b] focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50 font-montserrat",
            "text-sm",
            "placeholder:text-sm pl-5",
            suffix && "pr-12",
            className
          )}
          ref={ref}
          {...props}
        />

        {/* Suffix */}
        {suffix && (
          <div className="absolute inset-y-0 right-0 flex items-center justify-center w-12 h-full">
            {suffix}
          </div>
        )}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };